import { useSelector } from "react-redux";
import { selectOrdersCreatedItem } from "../../../redux/orders/selector";
import * as  R from 'ramda';
import { useEffect } from "react";
import { variants } from "../../../redux/variants/action";
import { selectVariantsListItems } from "../../../redux/variants/selector";
import { useAppDispatch } from "../../../hooks/hooks";
import { currency } from "../../../common/services/common.service";
import { useNavigate } from "react-router-dom";

const OrderDetailsMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const orderDetails = useSelector(selectOrdersCreatedItem)
  const variantLists = useSelector(selectVariantsListItems)
  const back = () => {
    navigate('/transport-agent/bookings')
  }
  const getProductName = (LogisticsVariantId: any) => {
    const Variant = R.find(
      (variant: any) => parseInt(
        variant.Id,
        10
      ) === parseInt(
        LogisticsVariantId,
        10
      ),
      variantLists?.result?.items
    )
    return Variant ? Variant.Name : ''
  }
  const orderData = orderDetails?.result?.items?.Records[0]?.message?.order
  useEffect(
    () => {
      dispatch(variants.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/variants/list`, entity: 'variants', jsonData: {}
      }))

    },
    []
  );
  return (
    <div className='p-5 w-full overflow-auto'>
      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-primary text-light rounded font-medium px-4 py-3 "
        >
          BackToBooking
        </button>
      </div>

      <div className=" uppercase font-bold mb-6">
        Order details :
      </div>

      <div className="font-medium text-sm mb-4 text-left">
        Booking ID : {orderData?.id}
      </div>

      <table className=" divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
            <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product</th>
            <th className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</th>

          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {orderData?.['@ondc/org/linked_order']?.items?.map((cardData: any, index: any) => (
            <tr key={index} className={`${index % 2 === 0 ? 'bg-gray-100' : 'bg-white'} `}>
              <td className="p-2">
                {cardData?.CategoryName}
              </td>
              <td className="p-2">
                {getProductName(cardData?.LogisticsVariantId)}
              </td>
              <td className="p-2">
                {cardData?.quantity?.count}
              </td>

            </tr>
          ))}
          <tr className='bg-gray-400'>
            <td className="p-2">
              Total Item : {orderData?.['@ondc/org/linked_order']?.items.length}
              <div >
                Total Price: {currency(orderData?.quote?.price?.value)}
              </div>
            </td>
            {/* <td className="p-4">{itemTotal}</td> */}

          </tr>
        </tbody>
      </table>
      <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3 pt-2'>

        <div className="bg-stone-50 mb-4 p-4 border rounded">
          <div className="text-xl border-b text-cyan-600 font-bold">
            Billing Address
          </div>
          <h1 className='pt-2'>{orderData?.billing?.name}
            ,</h1>
          <h1>{orderData?.billing?.address?.locality}
            ,</h1>


          <h1>  {orderData?.billing?.address?.city}

            {' '}

            -
            {orderData?.billing?.address?.area_code}
            ,
          </h1>
          <h1>{orderData?.billing?.address?.state}
            ,</h1>
          <h1>
            {orderData?.billing?.address?.country}
            ,
          </h1>
          <h1>
            Email:  {orderData?.billing?.email}
            ,
          </h1>
          <h1>
            Ph:  {orderData?.billing?.phone}
            .

          </h1>
        </div>

        <div className="bg-stone-50 mb-4 p-4 border rounded">
          <div className="text-xl border-b text-cyan-600 font-bold">
            From Address
          </div>
          <h1 className='pt-2'>{orderData?.fulfillments[0]?.start?.location?.address?.locality}
            ,</h1>

          <h1>  {orderData?.fulfillments[0]?.start?.location?.address?.city}

            {' '}

            -
            {orderData?.fulfillments[0]?.start?.location?.address?.area_code}
            ,
          </h1>
          <h1>
            {orderData?.fulfillments[0]?.start?.location?.address?.state}
            ,
          </h1>
          <h1>
            {orderData?.fulfillments[0]?.start?.location?.address?.country}
            ,
          </h1>
          <h1>
            Email:  {orderData?.fulfillments[0]?.start?.contact?.email}
            ,
          </h1>
          <h1>
            Ph:  {orderData?.fulfillments[0]?.start?.contact?.phone}
            .

          </h1>
        </div>
        <div className="bg-stone-50 mb-4 p-4 border rounded">
          <div className="text-xl border-b text-cyan-600 font-bold">
            To Address
          </div>
          <h1 className='pt-2'>{orderData?.fulfillments[0]?.end?.location?.address?.locality}
            ,</h1>

          <h1>  {orderData?.fulfillments[0]?.end?.location?.address?.city}

            {' '}

            -
            {orderData?.fulfillments[0]?.end?.location?.address?.area_code}
            ,
          </h1>
          <h1>
            {orderData?.fulfillments[0]?.end?.location?.address?.state}
            ,
          </h1>
          <h1>
            {orderData?.fulfillments[0]?.end?.location?.address?.country}
            ,
          </h1>
          <h1>
            Email:  {orderData?.fulfillments[0]?.end?.contact?.email}
            ,
          </h1>
          <h1>
            Ph:  {orderData?.fulfillments[0]?.end?.contact?.phone}
            .

          </h1>
        </div>
      </div>

    </div>


  );
};

export default OrderDetailsMobile;


